<div class="dx-card wide-card">
    <h4 class="content-block ap-green">Site Summary</h4>
    <div class="btndiv">
        <dx-button text="Close" type="default" class="backbtn" (onClick)="onClosebtnClicked($event)">
        </dx-button>
    </div>
    <div class="content-block">
        <dx-form *ngIf="show" id="form" [colCount]="4">
            <dxi-item>
                <div class="dx-field">
                    <div class="dx-field-label">Site ID:</div>
                    <div class="dx-field-value">
                        {{siteId}}
                    </div>
                </div>
            </dxi-item>
            <dxi-item>
                <div class="dx-field">
                    <div class="dx-field-label">Site Name:</div>
                    <div class="dx-field-value">
                        {{site.siteName}}
                    </div>
                </div>
            </dxi-item>
            <dxi-item>
                <div class="dx-field">
                    <div class="dx-field-label">Legal Entity Name:</div>
                    <div class="dx-field-value">
                        {{site.localCompanyName}}
                    </div>
                </div>
            </dxi-item>
            <!-- <dxi-item itemType="empty"></dxi-item> -->
            <dxi-item>
                <div class="dx-field">
                    <div class="dx-field-label">Country:</div>
                    <div class="dx-field-value">
                        {{site.country}}
                    </div>
                </div>
            </dxi-item>
            <dxi-item>
                <div class="dx-field">
                    <div class="dx-field-label">State Province:</div>
                    <div class="dx-field-value">
                        {{site.stateProvince}}
                    </div>
                </div>
            </dxi-item>
            <dxi-item>
                <div class="dx-field">
                    <div class="dx-field-label">City:</div>
                    <div class="dx-field-value">
                        {{site.city}}
                    </div>
                </div>
            </dxi-item>
            <dxi-item [colSpan]="2">
                <div class="dx-field">
                    <div class="dx-field-label">Owner Of Legal Entity and % Owned:</div>
                    <div class="dx-field-value">
                        {{companyOwners}}
                    </div>
                </div>
            </dxi-item>
            <dxi-item [colSpan]="2">
                <div class="dx-field">
                    <div class="dx-field-label">Site Notes/Comments:</div>
                </div>
                <dx-text-area [(value)]="site.comment" [height]="200" [readOnly]="true"></dx-text-area>
            </dxi-item>
            <dxi-item [colSpan]="2">
                <div class="dx-field">
                    <div class="dx-field-label">Site Gas Summary:</div>
                </div>
                <dx-data-grid #grid id="SiteGasSummaryGrid" [height]="200" [dataSource]="siteGasSummary"
                    [showBorders]="true" [allowColumnResizing]="true" [rowAlternationEnabled]="true"
                    [showRowLines]="true" [showColumnLines]="true" [showBorders]="true">
                    <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
                    <dxi-column dataField="industrialGas"></dxi-column>
                    <dxi-column dataField="supply"></dxi-column>
                    <dxi-column dataField="demand"></dxi-column>
                    <dxi-column dataField="uom"></dxi-column>
                </dx-data-grid>
            </dxi-item>
            <dxi-item itemType="button"
                [buttonOptions]="{ text: 'Edit Site', elementAttr:{ class: 'ap-blue-btn' } , useSubmitBehavior: false, onClick:editSite }">
            </dxi-item>
            <dxi-item itemType="button"
                [buttonOptions]="{ text: 'Add New Site', elementAttr:{ class: 'ap-blue-btn' }, useSubmitBehavior: false, onClick:addSite }">
            </dxi-item>
            <dxi-item itemType="empty">
            </dxi-item>
            <dxi-item itemType="empty"></dxi-item>
            <dxi-item [colSpan]="4">
                <div class="dx-field">
                    <div class="dx-field-label">Production Facilities:</div>
                </div>
                <dx-data-grid #ProductionFacilitiesGrid id="ProductionFacilitiesGrid" [height]="500"
                    [dataSource]="productionFacilities" [showBorders]="true" [allowColumnResizing]="true"
                    [rowAlternationEnabled]="true" [showRowLines]="true" [showColumnLines]="true" [showBorders]="true">
                    <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
                    <dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
                    <dxo-selection mode="single"></dxo-selection>
                    <dxi-column dataField="activityProcessFeedstockIndustry" [width]="200"></dxi-column>
                    <dxi-column dataField="status" [width]="100"></dxi-column>
                    <dxi-column dataField="capacity" [width]="100"></dxi-column>
                    <dxi-column dataField="oxygen" cellTemplate="cellTemplateO2" caption="O2"></dxi-column>
                    <dxi-column dataField="isOxygenSupply" caption="O2 Supply?" [width]="100"></dxi-column>
                    <dxi-column dataField="nitrogen" cellTemplate="cellTemplateN2" caption="N2"></dxi-column>
                    <dxi-column dataField="isNitrogenSupply" caption="N2 Supply?" [width]="100"></dxi-column>
                    <dxi-column dataField="hydrogen" cellTemplate="cellTemplateH2" caption="H2">
                        <dxo-format precision="4" type="fixedPoint"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="isHydrogenSupply" caption="H2 Supply?" [width]="100"></dxi-column>
                    <dxi-column dataField="syngas" cellTemplate="cellTemplateSyngas" [width]="100"
                        caption="Syngas"></dxi-column>
                    <dxi-column dataField="isSyngasSupply" caption="Syngas Supply?" [width]="100"></dxi-column>
                    <dxi-column dataField="carbonMonoxide" cellTemplate="cellTemplateCO" caption="CO"></dxi-column>
                    <dxi-column dataField="isCarbonMonoxidSupply" caption="CO Supply?" [width]="100"></dxi-column>
                    <dxi-column dataField="steam" cellTemplate="cellTemplateSteam" caption="Steam"
                        [width]="100"></dxi-column>
                    <dxi-column dataField="isSteamSupply" caption="Steam Supply?" [width]="100"></dxi-column>
                    <dxi-column dataField="power" caption="Power (MWe)" [width]="100"></dxi-column>
                    <dxi-column dataField="isPowerSupply" caption="Power Supply?" [width]="100"></dxi-column>
                    <dxi-column dataField="productionFacilityID" caption="Facility Id" [width]="100"></dxi-column>

                    <div *dxTemplate="let cell of 'cellTemplateO2'">
                        <div *ngIf="cell.data.oxygen"> {{ cell.text }} ({{cell.data.oxygenUOM}})</div>
                    </div>
                    <div *dxTemplate="let cell of 'cellTemplateH2'">
                        <div *ngIf="cell.data.hydrogen"> {{ cell.text }} ({{cell.data.hydrogenUOM}})</div>
                    </div>
                    <div *dxTemplate="let cell of 'cellTemplateN2'">
                        <div *ngIf="cell.data.nitrogen"> {{ cell.text }} ({{cell.data.nitrogenUOM}})</div>
                    </div>
                    <div *dxTemplate="let cell of 'cellTemplateSyngas'">
                        <div *ngIf="cell.data.syngas"> {{ cell.text }} ({{cell.data.syngasUOM}})</div>
                    </div>
                    <div *dxTemplate="let cell of 'cellTemplateCO'">
                        <div *ngIf="cell.data.carbonMonoxide"> {{ cell.text }} ({{cell.data.carbonMonoxideUOM}})</div>
                    </div>
                    <div *dxTemplate="let cell of 'cellTemplateSteam'">
                        <div *ngIf="cell.data.steam"> {{ cell.text }} ({{cell.data.steamUOM}})</div>
                    </div>
                </dx-data-grid>
            </dxi-item>
            <dxi-item itemType="button"
                [buttonOptions]="{ text: 'Edit Facility', disabled: productionFacilities.length == 0,  elementAttr:{ class: 'ap-blue-btn' }, useSubmitBehavior: false, onClick:editFacility }">
            </dxi-item>
            <dxi-item itemType="button"
                [buttonOptions]="{ text: 'Add Facility', elementAttr:{ class: 'ap-blue-btn' }, useSubmitBehavior: false, onClick:addFacility }">
            </dxi-item>
            <dxi-item itemType="empty"></dxi-item>
            <dxi-item itemType="empty"></dxi-item>
            <dxi-item [colSpan]="2">
                <div class="dx-field">
                    <div class="dx-field-label">Onsite Supply: Gases supplied to this site by onsite</div>
                </div>
                <dx-data-grid #grid id="OnsiteSupplyGrid" [height]="200" [dataSource]="onsiteSupplies"
                    [showBorders]="true" [allowColumnResizing]="true" [rowAlternationEnabled]="true"
                    [showRowLines]="true" [showColumnLines]="true" [showBorders]="true">
                    <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
                    <dxi-column dataField="materialName"></dxi-column>
                    <dxi-column dataField="quantity" caption="Quantity"></dxi-column>
                    <dxi-column dataField="uom"></dxi-column>
                    <dxi-column dataField="name" caption="Supplier"></dxi-column>
                </dx-data-grid>
            </dxi-item>
            <dxi-item [colSpan]="2">
                <div class="dx-field">
                    <div class="dx-field-label">Onsite Demand: Gases taken from this site by onsite</div>
                </div>
                <dx-data-grid #grid id="OnsiteDemandGrid" [height]="200" [dataSource]="onsiteDemands"
                    [showBorders]="true" [allowColumnResizing]="true" [rowAlternationEnabled]="true"
                    [showRowLines]="true" [showColumnLines]="true" [showBorders]="true">
                    <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
                    <dxi-column dataField="materialName"></dxi-column>
                    <dxi-column dataField="quantity" caption="Quantity"></dxi-column>
                    <dxi-column dataField="uom"></dxi-column>
                    <dxi-column dataField="name" caption="Customer"></dxi-column>
                </dx-data-grid>
            </dxi-item>
            <dxi-item [colSpan]="2">
                <div class="dx-field">
                    <div class="dx-field-label">Pipeline Supply: Gases supplied to this site by pipeline</div>
                </div>
                <dx-data-grid #PipelineSupplyGrid id="PipelineSupplyGrid" [height]="200" [dataSource]="pipelineSupplies"
                    [showBorders]="true" [allowColumnResizing]="true" [showRowLines]="true" [showColumnLines]="true"
                    [showBorders]="true" (onSelectionChanged)="onSelectionChanged($event)">
                    <dxo-selection mode="single"></dxo-selection>
                    <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
                    <dxi-column dataField="materialName"></dxi-column>
                    <dxi-column dataField="quantity"></dxi-column>
                    <dxi-column dataField="uom"></dxi-column>
                    <dxi-column dataField="pipelineName" caption="Pipeline"></dxi-column>
                </dx-data-grid>
            </dxi-item>
            <dxi-item [colSpan]="2">
                <div class="dx-field">
                    <div class="dx-field-label">Pipeline Demand: Gases taken from this site by pipeline</div>
                </div>
                <dx-data-grid #PipelineDemandGrid id="PipelineDemandGrid" [height]="200" [dataSource]="pipelineDemands"
                    [showBorders]="true" [allowColumnResizing]="true" [showRowLines]="true" [showColumnLines]="true"
                    [showBorders]="true" (onSelectionChanged)="onSelectionChanged($event)">
                    <dxo-selection mode="single"></dxo-selection>
                    <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
                    <dxi-column dataField="materialName"></dxi-column>
                    <dxi-column dataField="quantity"></dxi-column>
                    <dxi-column dataField="uom"></dxi-column>
                    <dxi-column dataField="pipelineName" caption="Pipeline"></dxi-column>
                </dx-data-grid>
            </dxi-item>
            <dxi-item itemType="button"
                [buttonOptions]="{ text: 'Edit Pipeline', disabled: pipelineDemands.length == 0, elementAttr:{ class: 'ap-blue-btn' }, useSubmitBehavior: false, onClick:editPipelineDemand }">
            </dxi-item>
            <dxi-item itemType="button"
                [buttonOptions]="{ text: 'Add Pipeline', elementAttr:{ class: 'ap-blue-btn' }, useSubmitBehavior: false, onClick:addPipelineDemand }">
            </dxi-item>
        </dx-form>
    </div>
    <dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
        [shading]="false" [closeOnOutsideClick]="false">
    </dx-load-panel>
</div>